import styled from 'styled-components';

export const CategoriesContainer = styled.div`
  display: grid;
  margin-top: 3rem;
  grid-gap: 2rem;
  grid-template-columns: repeat(auto-fill, minmax(290px, 1fr));
  overflow: hidden;
`;
